import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=88326fa4&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88326fa4",
  null
  
)

export default component.exports